//---------------------------------- Wholesaler Functionality -----------------------------------------------------------------
document.addEventListener("DOMContentLoaded", () => {
  if(window.location.href.includes("products")){
    ProductData();
  }
  if(window.location.href.includes("cart")){
    CartPage();
  } 
  $(".CartItems").each(function (item) {
    $(this).find(".quantity__input").change(function (event) {
      setTimeout(() => {
        location.reload();
      }, "1000");
    });
  });
}); 
Updateminicart();
function getAPIData(callback) {
    $.getJSON(
      "https://customapp.in/nispira/settings_json.php",
      function(data) {
        callback(data); // Invoke the callback function with the response data
      }
    );
  }
function updateCartItem(itemElement, productPrice, quantity, discountAmount, isDiscounted) {
    // Update cart item in mini cart
    const productOption = itemElement.find(".line_item_price");
    const LineItemsPrice = itemElement.find(".price");
    if (!isDiscounted) {
      productOption.html(formatMoney(productPrice, "${{amount}}"));
      LineItemsPrice.html(formatMoney(productPrice * quantity, "${{amount}}"));
    } else{
      const mainLinePrice = discountAmount.replace("$", "");
      productOption.html('<span class="original_price" style="text-decoration:line-through;">' + formatMoney(productPrice, "${{amount}}") + '</span><br><span class="miniitem--discounted-price">' + discountAmount + "</span>");
      LineItemsPrice.html('<span class="original_price" style="text-decoration:line-through;">' + formatMoney(productPrice * quantity, "${{amount}}") + '</span><br><span class="minilineitem--discounted-price">' + formatMoney(mainLinePrice * quantity * 100, "${{amount}}") + "</span>");
    }
    
    // Update cart item in normal cart
    // Replace the class names below with the correct class names for your normal cart
    const normalCartItemOption = itemElement.find(".line_item_price");
    const normalLineItemsPrice = itemElement.find(".price");
    if (!isDiscounted) {  
      normalCartItemOption.html(formatMoney(productPrice, "${{amount}}"));
      normalLineItemsPrice.html(formatMoney(productPrice * quantity, "${{amount}}"));
    }else{
    const mainLinePrice = discountAmount.replace("$", "");
      normalCartItemOption.html('<span class="original_price" style="text-decoration:line-through;">' + formatMoney(productPrice, "${{amount}}") + '</span><br><span class="normalitem--discounted-price">' + discountAmount + "</span>");
      normalLineItemsPrice.html('<span class="original_price" style="text-decoration:line-through;">' + formatMoney(productPrice * quantity, "${{amount}}") + '</span><br><span class="normallineitem--discounted-price">' + formatMoney(mainLinePrice * quantity * 100, "${{amount}}") + "</span>");
    }
  }
function processCartItems(data, cartItems, updateCallback) {
  const lineItems = [];
  let newTotal = 0;
  let discountApplied = false;
  let draftOrder = false;
  getCartData(function(cart) { 
    console.log(cart);
    cartItems.each(function () {
      const itemKey = $(this).attr("data-key");
      const cartItem = $.grep(cart.items, function (e) {
        return e.key == itemKey;
      })[0];
  
      const variantId = cartItem.variant_id;
      const quantity = cartItem.quantity;
      const productId = cartItem.product_id;
      const productPrice = cartItem.price;

      const isOfferStatus = Object.values(data).filter(arr =>
        arr.some(obj => obj.key === "offerstatus" && obj.value === "active")
      );
      const matchProductID = isOfferStatus.filter((arr) => {
        return arr.some(
          (obj) =>
            obj.key === "products" && obj.value.includes(productId)
        );
      });
  
      let discountAmount, discount, discountType;
      let offerUniqueName = "";
      let isDiscounted = false;
      let qtylevel;
  
      if (matchProductID.length === 0) {
        const result = isOfferStatus.filter((arr) => {
          return arr.some(
            (obj) => obj.key === "products" && obj.value === "all"
          );
        });
  
        if (result.length > 0) {
          const offerKeys = Object.keys(result);
          const offerWithQtylevel = offerKeys.find(key => {
            const offer = result[key];
            return Array.isArray(offer) && offer.some(obj => obj.hasOwnProperty('qtylevel'));
          });
          qtylevel = offerWithQtylevel ? result[offerWithQtylevel].find(obj => obj.hasOwnProperty('qtylevel')).qtylevel : null;
          // qtylevel = result[0][11].qtylevel;
          offerUniqueName = result[0].find(
            (obj) => obj.key === "offeruniquename"
          ).value;
        }
      } else {
        const offerKeys = Object.keys(matchProductID);
        const offerWithQtylevel = offerKeys.find(key => {
          const offer = matchProductID[key];
          return Array.isArray(offer) && offer.some(obj => obj.hasOwnProperty('qtylevel'));
        });
        qtylevel = offerWithQtylevel ? matchProductID[offerWithQtylevel].find(obj => obj.hasOwnProperty('qtylevel')).qtylevel : null;
        // qtylevel = matchProductID[0][11].qtylevel;
        offerUniqueName = matchProductID[0].find(
          (obj) => obj.key === "offeruniquename"
        ).value;
      }
      
      for (let i = 0; i < qtylevel.length; i++) {
        if (quantity >= qtylevel[i].fixed_qty && qtylevel[i].type === "percentage") {
          discount = qtylevel[i].discount;
          discountType = qtylevel[i].type;
          const discountPrice = parseFloat(productPrice - (productPrice * discount) / 100).toFixed(2);
          discountAmount = formatMoney(discountPrice, "${{amount}}");
          isDiscounted = true;
        } else if (quantity >= qtylevel[i].fixed_qty && qtylevel[i].type === "fixedprice") {
          discount = qtylevel[i].discount;
          discount_type = qtylevel[i].type;
          var discountprice = parseFloat(discount).toFixed(2);
          discountAmount = formatMoney(discountprice * 100, "${{amount}}");
          isDiscounted = true;
        }
      }
    
      if (isDiscounted) {
        updateCartItem($(this), productPrice, quantity, discountAmount, true);
        discountApplied = true;
      }
      else{
        updateCartItem($(this), productPrice, quantity, discountAmount, false);
      }
      lineItems.push({
        variant_id: variantId,
        quantity: quantity,
        discount: discount,
        discount_type: discountType,
        offeruniquename: offerUniqueName,
        Productprice: productPrice,
      });
          
      var linePriceE1="";
      let totalFlag = false;

      if($(this).find('.normallineitem--discounted-price').length > 0){
        linePriceEl = $(this).find(".normallineitem--discounted-price").text();
        totalFlag = true;
      }
      else if($(this).find('.minilineitem--discounted-price').length > 0){
        linePriceEl = $(this).find('.minilineitem--discounted-price').text();
        totalFlag = true;
      }
      
      if (totalFlag) {
        var linenewPrice = parseFloat(linePriceEl.replace("$", ""));
        newTotal += linenewPrice;
      }
      else {
        let cartitemsLineprice = formatMoney(
          cartItem.line_price,
          "${{amount}}"
        );
        let lineoldPrice = parseFloat(
          cartitemsLineprice.replace("$", "")
        );
        newTotal += lineoldPrice;
      }
    });
    if (discountApplied) {
      var form = document.querySelector("#cart_form");
      var update = form.querySelector('input[name="updates[]"]');
      $(update).click();
      var newTotalPrice = parseFloat(newTotal * 100).toFixed(2);
    
      $(".cart_subtotal").html(
        '<span class="originaltoal_price" style="text-decoration:line-through;">' +
          formatMoney(cart.original_total_price, "${{amount}}") +
          '</span><br><span class="lineitem--discounted-price">' +
          formatMoney(newTotalPrice, "${{amount}}") +
          "</span>"
      );
      $('.cart_subtotal').html('<span class="right"><span class="originaltoal_price" style="text-decoration:line-through;">' + formatMoney(cart.original_total_price, "${{amount}}") + '</span>  <span class="lineitem--discounted-price">' + formatMoney(newTotalPrice, "${{amount}}") + "</span></span><span>Subtotal</span>");
      draftOrder = true;  
    }
    if(draftOrder){
      let checkoutSelector = document.querySelectorAll("#checkout-no");
      checkoutSelector.forEach(function (node) {
        if (!node.hasEventListener) {
          node.hasEventListener = true;
          node.addEventListener("click", async function (event) {
            try {
              const checkoutUrl = await DraftOrder(lineItems);
              window.location.href = checkoutUrl;
            } catch (error) {
              console.error(error);
            }
          });
        }
      }); 
    } 
  }); 
}
function getCartData(callback){
  $.getJSON("/cart.js", function (cart) {
    if (typeof callback === "function") {
      callback(cart);
    }
  });  
}
function Updateminicart(){
 getAPIData(function (data) {
   const miniCartItems = $(".header_cart_main .cart_items .cart_item"); // Assuming the mini cart items have the class "mini-cart-item"
   processCartItems(data, miniCartItems, updateCartItem);
 });
  //------ Mobile Minicart Code ---------------
 setTimeout(() => {
  if($('.header_cart_main .cart_item').length > 0){
    const priceElements = $('.cart_item .price');
    const addedcartItem = $('.cart_item');
    for (let i = 0; i < addedcartItem.length; i++) {
      const cartItem = addedcartItem[i];
      const itemKey = cartItem.getAttribute('data-key');
      const cartPrice = cartItem.querySelector('.price');
      const priceElement = Array.from(priceElements).find((element) => {
        const dataKey = element.closest('.cart_item').dataset.key;
        return dataKey === itemKey;
      });
      if(priceElement && cartPrice){
         priceElement.innerHTML = cartPrice.innerHTML;
      }
    }
  }
 },"1000");
}
function CartPage(){
  // Call the API and process cart items
  getAPIData(function (data) {
    const normalCartItems = $(".cart_item"); // Assuming the normal cart items have the class "normal-cart-item"
    processCartItems(data, normalCartItems, updateCartItem);
    
  });
} 
function ProductData() {
  getAPIData(function (data) {
    const product_id = $(".volume-discount").attr("data-product-id");
    const productPriceElement = $(".current_price")[0];
    const price = productPriceElement ? productPriceElement.getAttribute("data-price") : null;

    const isOfferStatus = Object.values(data).filter(arr =>
        arr.some(obj => obj.key === "offerstatus" && obj.value === "active")
    );
    const isOfferTrue = isOfferStatus.filter(arr =>
      arr.some(obj => obj.key === "displayoffertable" && obj.value === true)
    );
    const matchProID = isOfferTrue.filter(arr =>
      arr.some(obj => obj.key === "products" && obj.value.includes(product_id))
    );
    
    let qtylevel = [];
    if (matchProID.length == 0) {
      const result = isOfferTrue.filter(arr =>
          arr.some(obj => obj.key === "products" && obj.value === "all")
      );
    if ($(".volume-discount").length > 0) {
        const offerKeys = Object.keys(result);
        const offerWithQtylevel = offerKeys.find(key => {
          const offer = result[key];
          return Array.isArray(offer) && offer.some(obj => obj.hasOwnProperty('qtylevel'));
        });
        qtylevel = offerWithQtylevel ? result[offerWithQtylevel].find(obj => obj.hasOwnProperty('qtylevel')).qtylevel : null;
        // qtylevel = result[0][11].qtylevel;
      }
    } else {
      if ($(".volume-discount").length > 0) {
        const offerKeys = Object.keys(matchProID);
        const offerWithQtylevel = offerKeys.find(key => {
          const offer = matchProID[key];
          return Array.isArray(offer) && offer.some(obj => obj.hasOwnProperty('qtylevel'));
        });
        qtylevel = offerWithQtylevel ? matchProID[offerWithQtylevel].find(obj => obj.hasOwnProperty('qtylevel')).qtylevel : null;
        // qtylevel = matchProID[0][11].qtylevel;
      }
    }
    
    if (qtylevel.length > 0) {
      createDiscountTable(qtylevel);
      const quantitySelectors = document.querySelectorAll(".product-form__input, .quantity-button");
      quantitySelectors.forEach(node => {
        node.addEventListener("click", async function (event) {
          const quantity = node.closest(".quantity-wrap").querySelector("input").value;
          console.log("quantity-->",quantity);
          // applyDiscount(qtylevel, quantity, price);
        });
      });
    } 
  });
}
function applyDiscount(qtylevel, quantity, productPrice) {
  let discountAmount, discount, discount_type;
  let isDiscounted = false;
   
  for (let i = 0; i < qtylevel.length; i++) {
    
    if (quantity >= qtylevel[i].fixed_qty && qtylevel[i].type === "percentage") {
      discount = qtylevel[i].discount;
      discount_type = qtylevel[i].type;
      const discountPrice = parseFloat(productPrice - (productPrice * discount) / 100).toFixed(2);
      discountAmount = formatMoney(discountPrice, "${{amount}}");
      isDiscounted = true;
    } else if (quantity >= qtylevel[i].fixed_qty && qtylevel[i].type === "fixedprice") {
      discount = qtylevel[i].discount;
      discount_type = qtylevel[i].type;
      const discountPrice = parseFloat(discount).toFixed(2);
      discountAmount = formatMoney(discountPrice * 100, "${{amount}}");
      isDiscounted = true;
    }
  }
  const discountedPriceElem = document.querySelector(".price-item--discounted-price");
  if (discountedPriceElem) {
      if (isDiscounted) {
        // update the existing element with the new value
        discountedPriceElem.textContent = discountAmount;
        const myDiv = document.querySelector("#pdp-prices .product-price__price span:nth-child(1)");
        myDiv.style.textDecoration = "line-through";
        discountedPriceElem.style.display = "block";
      } else {
        discountedPriceElem.style.display = "none";
        const myDiv = document.querySelector("#pdp-prices .product-price__price span:nth-child(1)");
        myDiv.style.textDecoration = "none";
      }
    } 
  else {
     if (isDiscounted && document.querySelector(".product__info-container #pdp-price-wrap .product-price__price")) {
      const myDiv = document.querySelector("#pdp-prices .product-price__price span:nth-child(1)");
      myDiv.style.textDecoration = "line-through";
      document.querySelector("#pdp-prices .product-price__price").innerHTML +=
        '<br><span class="price-item--discounted-price">' +
        discountAmount +
        "</span>";
    }
  }
  // return { discountAmount, discount, discount_type };
}
function createDiscountTable(qtylevel) {
    $.getJSON(
      "https://customapp.in/nispira/language_settings_json.php",
      function(data) {
        //--------- get store language------------------------- 
        const languageElement = document.querySelector('html').getAttribute('lang');
        const storeLanguage = languageElement ? languageElement.toLowerCase() : '';
        
        const matchedData = data[storeLanguage];
        console.log(matchedData);
        const minimumQuantityValue = matchedData.find(item => item.key === 'Minimum quantity')?.value || '';
        const Discount = matchedData.find(item => item.key === 'Discount')?.value || '';
        const off = matchedData.find(item => item.key === 'Off text')?.value || '';
        const Each = matchedData.find(item => item.key === 'Each text')?.value || '';
        const miniminQtyBefore = matchedData.find(item => item.key === 'Minimum quantity before')?.value || '';
        const miniminQtyAfter = matchedData.find(item => item.key === 'Minimum quantity after')?.value || '';
        
        //------- Add Settings value in Table---------- 
        const table = document.createElement("table");
        table.className = "volume-tabel";
        const trOne = document.createElement("tr");
        const thOne = document.createElement("th");
        thOne.innerHTML = minimumQuantityValue;
        const thTwo = document.createElement("th");
        thTwo.innerHTML = Discount;
        
        const thTwo1 = document.createElement("th");
        thTwo1.innerHTML = 'Select';       
        trOne.appendChild(thTwo1);
        trOne.appendChild(thOne);
        trOne.appendChild(thTwo);
        table.appendChild(trOne);
        for (let i = 0; i < qtylevel.length; i++) {
          var row = table.insertRow();          
          row.className = "customqty qtylevel_"+qtylevel[i].fixed_qty;
          row.insertCell(0).innerHTML = '<input type="radio" id="qtr" name="qtyselector" class="customqtyinput inputbox_'+qtylevel[i].fixed_qty+'"/>';          
          row.insertCell(1).innerHTML = miniminQtyBefore +" " + qtylevel[i].fixed_qty + " " + miniminQtyAfter;
          if (qtylevel[i].type === "percentage") {
            row.insertCell(2).innerHTML = qtylevel[i].discount + "% " + off;
          } else {
            row.insertCell(2).innerHTML = Each + " " + formatMoney(qtylevel[i].discount * 100, "${{amount}}");
          }
        }
        if ($(".volume-discount").length > 0) {
          const myTable = document.querySelector(".volume-discount");    
          const mycheading = document.createElement("h2");
          mycheading.innerHTML = "Buy More, Save More";
          myTable.appendChild(mycheading);
          myTable.appendChild(table);
          $("table td:nth-child(1)").addClass("discount-quantity");
          $("table td:nth-child(2)").addClass("discount-price");
        }
      }
    );

    
  }
function DraftOrder(lineItems) {
  return new Promise((resolve, reject) => {
    const line_items = [];
    // Loop through each line item and add it to the request body
    for (let i = 0; i < lineItems.length; i++) {
      const lineItem = lineItems[i];
      const variantID = lineItem.variant_id;
      const quantity = lineItem.quantity;
      const discount = lineItem.discount;
      const discount_type = lineItem.discount_type;
      const uniquename = lineItem.offeruniquename;
      const price = lineItem.Productprice;
      const applied_discount = discount
        ? {
            description:
              discount_type === "percentage"
                ? `${discount}% Off On this Product`
                : `GET EACH ITEM FOR ${discount}`,
            value_type:
              discount_type === "percentage"
                ? "percentage"
                : "fixed_amount",
            value:
              discount_type === "percentage"
                ? discount
                : price / 100 - discount,
            title: null,
          }
        : null;
      const properties = discount
        ? [
            {
              name: "Offer unique name",
              value: uniquename,
            },
          ]
        : null;

      line_items.push({
        variant_id: variantID,
        quantity: quantity,
        applied_discount: applied_discount,
        properties: properties,
      });
    }
    console.log("line_items--->", line_items);

    var obj = {
      draft_order: {
        line_items: line_items,
        note: "Added Order by Volume Discount APP",
        tags:"Wholesale App"
      },
    };

    fetch("https://lacomptoirdefrance.com/admin/api/2023-04/draft_orders.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Access-Token": "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",
      },
      body: JSON.stringify(obj),
    })
    .then((response) => response.json())
    .then((data) => {
        var checkout_url = data.draft_order.invoice_url;
        setTimeout(() => {
          resolve(checkout_url);
        },"500");  
    })
   .catch((error) => {
        reject(error);
    });
  });
}
function formatMoney(cents, format) {
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || "${{amount}}";

  function formatWithDelimiters(number, precision, thousands, decimal) {
    thousands = thousands || ",";
    decimal = decimal || ".";

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split(".");
    var dollarsAmount = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      "$1" + thousands
    );
    var centsAmount = parts[1] ? decimal + parts[1] : "";

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ",", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ",", ".");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
  }

  return formatString.replace(placeholderRegex, value);
}
